/** Deadline for legacy Promise APIs, including ones that swallow HTTP failures. */
export async function withLoadingDeadline<T>(operation: Promise<T>, milliseconds = 30000): Promise<T> {
  let timer: ReturnType<typeof setTimeout>;
  try {
    return await Promise.race([
      operation,
      new Promise<never>((_, reject) => { timer = setTimeout(() => reject(new Error('Loading deadline exceeded')), milliseconds); })
    ]);
  } finally { clearTimeout(timer); }
}
